import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { AuthProvider } from "./auth/AuthContext.js";
import App from "./App.js";
import "./i18n/index.js";
import "./styles/tokens.css";
import { registerSW } from "virtual:pwa-register";

// autoUpdate: the new service worker activates immediately and the page
// reloads onto it, so users never run a stale build. Re-check on an interval
// and when the tab regains focus so long-lived tabs also pick up deploys.
// A new worker takes control as soon as it installs (skipWaiting +
// clientsClaim). Reload once so the page runs the matching build. Skipped on
// the very first install, when there is no previous controller to replace.
if ("serviceWorker" in navigator) {
  const hadController = !!navigator.serviceWorker.controller;
  let reloaded = false;
  navigator.serviceWorker.addEventListener("controllerchange", () => {
    if (!hadController || reloaded) return;
    reloaded = true;
    window.location.reload();
  });
}

registerSW({
  immediate: true,
  onRegisteredSW(_url, registration) {
    if (!registration) return;
    const check = () => registration.update().catch(() => {});
    setInterval(check, 60 * 60 * 1000);
    document.addEventListener("visibilitychange", () => {
      if (document.visibilityState === "visible") check();
    });
  },
});

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <BrowserRouter>
      <AuthProvider>
        <App />
      </AuthProvider>
    </BrowserRouter>
  </React.StrictMode>
);
